import { windowUtils } from 'utils/windowUtils/windowUtils';

export const BrowserRepository = {
  getFlywireSubdomain() {
    const host = windowUtils.getHost();
    const match = host.match(/(flywire.*)/) || [];

    return match[0];
  },
};
